export default {
  prabayar: []
}